import { SvgIcon } from 'components'
import styled from 'styled-components'
import { css } from 'styled-components'

export const IconWrapper = styled.div<{ showText: boolean }>`
  position: relative;
  top: -5px;
  height: 12px;
  svg {
    width: 12px;
    height: 12px;
    position: absolute;
    left: 0;
    transition: opacity 0.4s ease-in-out;
    & > path {
      stroke: ${({ theme, showText }) =>
        showText ? theme.primaryFontColor : theme.secondaryFontColor};
    }
  }
`

export const SizedSvg = styled(SvgIcon)`
  svg {
    width: 14px;
    height: 14px;
  }
`
export const StyledSvg = styled(SizedSvg)<{ clicked: boolean }>`
  opacity: ${({ clicked }) => (clicked ? 1 : 0)};
`

export const SpanWrapper = styled.div<{ textOffset?: string }>`
  position: absolute;
  width: 24px;
  top: 15px;
  ${({ textOffset }) =>
    textOffset &&
    css`
      margin-left: ${textOffset};
    `}
`
